import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DocumentsService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useDeleteDocumentLinkMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (documentLinkId: number) => {
      return DocumentsService.documentsServiceDeleteDocumentLink({
        path: { id: documentLinkId },
      });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: queryKeys.documents.links(),
        }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.documents.metadata(),
        }),
      ]);
    },
  });
};
